import React, { useState } from "react";
import { Modal, Button, DatePicker, Slider, InputNumber, Select } from "antd";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";

const VesselDetailFilter = ({
  visible,
  onCancel,
  onApply,
}) => {
  const currentYear = dayjs().year();
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [complianceBalance, setComplianceBalance] = useState(['', '']);
  const [ghg, setGhg] = useState(['', '']);
  const [penalty, setPenalty] = useState(['', '']);
  const [shipOwner, setShipOwner] = useState(null);
  const [pic, setPic] = useState(null);
  const dispatch = useDispatch();


  const { vesselDetailsTableFilterDataLists } = useSelector(
    (state) => state.vesselDetails
  );
  
  console.log("vesselDetailsTableFilterDataLists",vesselDetailsTableFilterDataLists)
  const shipOwnerSet = new Set();
  const picSet = new Set();

  vesselDetailsTableFilterDataLists?.forEach(item => {
    if (item.pic__company_name) shipOwnerSet.add(item.pic__company_name);
    if (item.pic__name) picSet.add(item.pic__name);
  });

  const shipOwners = Array.from(shipOwnerSet);
  const pics = Array.from(picSet);

  const handleYearChange = (date) => {
    if (date) {
      setSelectedYear(date.year());
    } else {
      setSelectedYear(currentYear);  
    }
  };
  

  const handleApply = () => {
    onApply({
      year: selectedYear ? selectedYear : currentYear,
      complianceBalance: complianceBalance[0] !== '' && complianceBalance[1] !== '' ? complianceBalance : '',
      ghg: ghg[0] !== '' && ghg[1] !== '' ? ghg : '',
      penalty: penalty[0] !== '' && penalty[1] !== '' ? penalty : '',
      shipOwner: shipOwner || '',
      pic: pic || '',
    });
  };

  const handleClearComplianceBalance = () => setComplianceBalance(['', '']);
  const handleClearGhg = () => setGhg(['', '']);
  const handleClearPenalty = () => setPenalty(['', '']);

  const sliderWidth = "21.5vw"; // Set a fixed width for the slider and input to ensure alignment.

  // Function to handle changes to the input numbers
  const handleInputNumberChange = (value, index, type) => {

    const parsedValue = parseFloat(value); // Use parseFloat for other types
    const validValue = isNaN(parsedValue) ? 0 : parsedValue;

    if (type === "complianceBalance") {
      if (validValue < -50000000 || validValue > 50000000) {
        return;
      }
      const newValues = [...complianceBalance];
      newValues[index] = validValue;
      if (!newValues[0]) newValues[0] = 0;
      if (!newValues[1]) newValues[1] = 0;
      setComplianceBalance(newValues);
    } else if (type === "ghg") {
      if (validValue < -1000 || validValue > 1000) {
        return;
      }
      const newValues = [...ghg];
      newValues[index] = validValue;
      if (!newValues[0]) newValues[0] = 0;
      if (!newValues[1]) newValues[1] = 0;
      setGhg(newValues);
    } else if (type === "penalty") {
      if (validValue < 0 || validValue > 1000000) {
        return;
      }
      const newValues = [...penalty];
      newValues[index] = validValue;
      if (!newValues[0]) newValues[0] = 0;
      if (!newValues[1]) newValues[1] = 0;
      setPenalty(newValues);
    }
  };
  
  
  const handleSliderChange = (value, type) => {
    if (type === "complianceBalance") {
      if (value < -50000000 || value > 50000000) {
        return;
      }
      setComplianceBalance(value);
    } else if (type === "ghg") {
      if (value < -1000 || value > 1000) {
        return;
      }
      setGhg(value);
    } else if (type === "penalty") {
      if (value < 0 || value > 1000000) {
        return;
      }
      setPenalty(value);
    }
  };

  // Function to check if the left value is greater than the right value and return a message
  const checkLeftGreaterThanRight = (type, left, right) => {
    if (left > right) {
      if (type === "ghg") {
        return "Left input of GHG cannot be greater than right input of GHG!";
      } else if (type === "penalty") {
        return "Left input of Penalty cannot be greater than right input of Penalty!";
      } else if (type === "compliance_balance") {
        return "Left input of Compliance Balance cannot be greater than right input of Compliance Balance!";
      }
    }
    return ""; // Return empty string if no condition is met
  };
  
  return (
    <Modal
      className="vessel-detail-filter"
      visible={visible}
      onCancel={onCancel}
      footer={[<Button key="apply" type="primary" onClick={handleApply}>Apply</Button>]}
      closable={true}
      title={<div style={{fontWeight:500}}>Filters</div>}
      centered
    >
      <div>
        <div style={{ marginBottom: "16px" }}>
          <label>Select Year: </label>
          <DatePicker
            picker="year"
            value={selectedYear ? dayjs().year(selectedYear) : dayjs().year(currentYear)}
            onChange={handleYearChange}
            format="YYYY"
            style={{ width: "100%" }}
            placeholder={"Select Year"}
          />
        </div>

        {/* Compliance Balance Section */}
        <div style={{ marginBottom: "16px" }}>
          <label>Compliance Balance (MT CO<sub>2</sub>e)</label>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Slider
              range
              min={-50000000}
              max={50000000}
              step={1}
              value={complianceBalance.map(v => v !== '' ? v : 0)}
              onChange={(value) => handleSliderChange(value, "complianceBalance")}
              style={{ width: sliderWidth }}
            />
            <Button onClick={handleClearComplianceBalance} style={{ marginLeft: '8px' }}>
              Clear
            </Button>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', width: sliderWidth }}>
            <InputNumber
              min={-50000000}
              max={50000000}
              step={1}
              value={complianceBalance[0]}
              onChange={(value) => handleInputNumberChange(value, 0, "complianceBalance")}
              style={{ width: '45%' }}
            />
            <span>to</span>
            <InputNumber
              min={-50000000}
              max={50000000}
              step={1}
              value={complianceBalance[1]}
              onChange={(value) => handleInputNumberChange(value, 1, "complianceBalance")}
              style={{ width: '45%' }}
            />
          </div>
          {/* Warning message for Compliance Balance */}
          {checkLeftGreaterThanRight("compliance_balance",complianceBalance[0], complianceBalance[1]) && (
            <div style={{ color: 'red', fontSize: '12px', marginTop: '8px' }}>
              {checkLeftGreaterThanRight("compliance_balance",complianceBalance[0], complianceBalance[1])}
            </div>
          )}
        </div>

        {/* GHG Section */}
        <div style={{ marginBottom: "16px" }}>
          <label>GHGIE</label>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Slider
              range
              min={-1000}
              max={1000}
              step={0.1}
              value={ghg.map(v => v !== '' ? v : 0)}
              onChange={(value) => handleSliderChange(value, "ghg")}
              style={{ width: sliderWidth }}
            />
            <Button onClick={handleClearGhg} style={{ marginLeft: '8px' }}>
              Clear
            </Button>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', width: sliderWidth }}>
            <InputNumber
              min={-1000}
              max={1000}
              step={0.1}
              value={ghg[0]}
              onChange={(value) => handleInputNumberChange(value, 0, "ghg")}
              style={{ width: '45%' }}
            />
            <span>to</span>
            <InputNumber
              min={-1000}
              max={1000}
              step={0.1}
              value={ghg[1]}
              onChange={(value) => handleInputNumberChange(value, 1, "ghg")}
              style={{ width: '45%' }}
            />
          </div>
          {/* Warning message for GHG */}
          {checkLeftGreaterThanRight("ghg",ghg[0], ghg[1]) && (
            <div style={{ color: 'red', fontSize: '12px', marginTop: '8px' }}>
              {checkLeftGreaterThanRight("ghg",ghg[0], ghg[1])}
            </div>
          )}
        </div>

        {/* Penalty Section */}
        <div style={{ marginBottom: "16px" }}>
          <label>Penalty (€)</label>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Slider
              range
              min={0}
              max={1000000}
              value={penalty.map(v => v !== '' ? v : 0)}
              onChange={(value) => handleSliderChange(value, "penalty")}
              style={{ width: sliderWidth }}
            />
            <Button onClick={handleClearPenalty} style={{ marginLeft: '8px' }}>
              Clear
            </Button>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', width: sliderWidth }}>
            <InputNumber
              min={0}
              max={1000000}
              value={penalty[0]}
              onChange={(value) => handleInputNumberChange(value, 0, "penalty")}
              style={{ width: '45%' }}
            />
            <span>to</span>
            <InputNumber
              min={0}
              max={1000000}
              value={penalty[1]}
              onChange={(value) => handleInputNumberChange(value, 1, "penalty")}
              style={{ width: '45%' }}
            />
          </div>
          {/* Warning message for Penalty */}
          {checkLeftGreaterThanRight("penalty",penalty[0], penalty[1]) && (
            <div style={{ color: 'red', fontSize: '12px', marginTop: '8px' }}>
              {checkLeftGreaterThanRight("penalty",penalty[0], penalty[1])}
            </div>
          )}
        </div>
        <div style={{ marginBottom: "16px" }}>
          <label>Ship Owner</label>
          <Select
            allowClear
            showSearch
            placeholder="Select Ship Owner"
            value={shipOwner}
            onChange={(value) => setShipOwner(value)}
            style={{ width: "100%" }}
          >
            {shipOwners.map((owner) => (
              <Select.Option key={owner} value={owner}>{owner}</Select.Option>
            ))}
          </Select>
        </div>

        <div style={{ marginBottom: "16px" }}>
          <label>PIC</label>
          <Select
            allowClear
            showSearch
            placeholder="Select PIC"
            value={pic}
            onChange={(value) => setPic(value)}
            style={{ width: "100%" }}
          >
            {pics.map((person) => (
              <Select.Option key={person} value={person}>{person}</Select.Option>
            ))}
          </Select>
        </div>
      </div>
    </Modal>
  );
};

export default VesselDetailFilter;
